export enum FreightValueType {
  "All" = 'ALL',
  'Trash' = 'NO_VALUE',
  '$1-$149' = '1_149',
  '$150-$499' = '150_499',
  '$500-$999' = '500_999',
  '$1,000-$4,999' = '1000_4999',
  '$5,000 or more' = '5000_ABOVE',
}
